import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BULSATCODE, COUPON, login, operatorLogin, operatorsList, R_VOUCHER_SIGNIN, VODAFONE_ROMANIA, VOUCHER, VOUCHER_SIGNIN } from 'src/app/shared/constants';
import { environment } from 'src/environment';
import { BaseService, SettingsService, StorageService } from '.';
import { ConfigurationService } from './configuration.service';
import { DatalayerService } from './datalayer.service';
import { SubscriptionService } from './subscription.service';
import { UikitService } from './uikit.service';
import * as $ from 'jquery';
import { LoggerService } from '../authentication/logger.service';
import { VoucherService } from './voucher.service';
@Injectable()
export class OperatorService{
  displayPayment: string = '0';
  memorySource = new BehaviorSubject<any>({});
  memoryStorage = this.memorySource.asObservable();
  constructor(private http: HttpClient, private storageService: StorageService, private uikitService: UikitService,
    private settingsService: SettingsService, private baseService: BaseService, private datalayerService: DatalayerService,
    private configService: ConfigurationService, private router: Router, private route: ActivatedRoute, private subscriptionService: SubscriptionService,
    private loggerService: LoggerService, private voucherService:VoucherService
    ) { }

// this service call get the response for list of operter details
  getOperators(): Promise<any>{
    const operatorsUrl = environment.apiEndpoint + environment.version + operatorsList;
    const region: string = this.storageService.getLocalStore('region');
    const locale: string = this.storageService.getLocalStore('locale');
    const params: HttpParams = new HttpParams()
      .set('loacle', locale)
      .set('region', region);
    return new Promise((resolve, reject)=>{
      this.http.get<any>(operatorsUrl, { params }).subscribe((res)=>{
          resolve(res.data);
        }, (err)=>{
          resolve(err);
        }
      )
    })
  }
// this service call resoponse for User login details.
  loginFn(data) {
    return new Promise((resolve, reject)=>{
      this.operatorLogin(data).subscribe(
        async (response) => {
          this.baseService.signLoaderSource.next(false);
          if (response.status_code === 302) {
            this.uikitService.staticErrorMessage(response.message);
            setTimeout(()=>{
              window.location.href = response.redirect_url;
            }, 5000);
          }
          if (response.status_code === 200) {
            const respData = response.data;
            if(respData.profiles){
              this.loggerService.userProfilesSubject.next(respData.profiles);
              this.storageService.setLocalStore('profileLength', respData?.profiles?.length);
            }
            const uId = respData.user_id;
            this.loggerService.isVoucherSuspended = respData?.user?.voucher?.is_voucher_suspended;
            this.loggerService.userTelco = respData?.user?.user_telco;
            this.subscriptionService.userType = respData?.user?.user_type || 0;
            if(this.settingsService.dEngageFlag != 0 && window?.dengage){
              window.dengage('setContactKey', uId);
            }
            if(this.settingsService.enableMatomoAnalytics){
              const bodyScript = "<script>var _paq = window._paq = window._paq || []; _paq.push(['setUserId', '" + uId + "']);</script>";
              $('body').append(bodyScript);
            }
            let userType = 'Free User';
            let operator_name = '';
            this.storageService.setLocalStore('a_t', respData.access_token);
            this.storageService.setLocalStore('r_t', respData.refresh_token);
            this.storageService.setLocalStore('u_id', uId);
            this.storageService.setLocalStore('logged_in', respData.logged_in);
            this.storageService.setLocalStore("sso_or_ftp", '1');
            let cookieuName = 'u_id';
            let cookieuValue = uId;
            document.cookie = cookieuName + "=" + cookieuValue + ";domain="+environment.cookieDomain+";path=/";
            const updateMemoryData = {
              login_by: respData.user_login_by,
              user_picture: respData.user_picture,
              user_name: respData.user_name,
              user_type: respData.user_type,
              user_telco: respData.user_telco,
              is_voucher_applied: respData?.is_voucher_applied,
              partner_name: respData?.voucher?.partner_name,
              partner_description: respData?.voucher?.partner_description,
              one_time_subscription: respData.one_time_subscription,
              u_id: uId
            };
            if (respData.user_telco) {
              userType = 'Operator User';
              operator_name = respData.user_telco;
            } else if (respData.is_voucher_applied && respData.is_voucher_applied == 1) {
              userType = 'Voucher User';
              operator_name = respData.voucher.partner_name + '-' + respData.voucher.partner_description;
            } else if (respData.user_type === 1) {
              userType = 'Paid User';
            }
            this.baseService.showCardData.next({ no_past_due: true, session_id: undefined })
            this.storageService.setLocalStore('user_type', userType);
            this.storageService.setLocalStore('operator_name', operator_name);
            this.loggerService.memorySource.next(updateMemoryData);
            this.storageService.setLocalStore('sessionStorage', updateMemoryData);
            this.storageService.setLocalStore('event_user_status', respData.user_type);
            this.baseService.guestSource.next(false);
            const datalayerData = {
              event: 'GAEvent',
              eventCategory: 'Membership Actions',
              eventAction: 'Login',
              eventLabel: respData.user_telco != '' ? 'Success - Operator' : 'Success - ' + respData.user_login_by,
              loginStatus: 'True',
              userId: uId,
              notificationStatus: localStorage.getItem('emailNotify') ||  'False',
              region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
              platform: this.baseService.browserType,
              userType: this.storageService.getLocalStore('user_type'),
              operatorName: this.storageService.getLocalStore('operator_name')
            };
            this.datalayerService.addDatalayer(datalayerData);
            let loginSucessMsg = this.configService.localeKeys?.["common_keys.login_successful.text"];
            if (this.router.url !== R_VOUCHER_SIGNIN) {
              this.uikitService.staticSuccessMessage(loginSucessMsg);
            }
            const authenticate = this.storageService.getLocalStore('authenticate');
            const contentURL = this.storageService.getLocalStore('contentURL');
            const discountType = this.storageService.getLocalStore('discount_type');
            const discountCode = this.storageService.getLocalStore('discount_code');
            const queryParamTv = this.route.snapshot.queryParams['app'];
            if (queryParamTv === this.baseService.keyQueryParamTV || queryParamTv === this.baseService.keyQueryParamAppleTV){
              if(this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
              if(this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
            } else if ((respData.is_voucher_applied === "1" || respData.user_type === 1) && this.router.url === R_VOUCHER_SIGNIN) {
              if (respData.is_voucher_applied === "1") {
                this.uikitService.staticErrorMessage(this.configService.localeKeys?.["operator.voucher_is_active.text"] || 'You have an active voucher already');
              } else if (respData.user_type === 1) {
                this.uikitService.staticErrorMessage(this.configService.localeKeys?.["plans.subscription_is_active.text"] || 'You already have an active subscription!');
              }
              this.router.navigateByUrl('/home')
            }
            else if (discountCode && discountType === VOUCHER) {
              const Coupendata = { voucher_code: discountCode };
              const couponResp: any = await this.subscriptionService.applyCoupon(Coupendata);
              if (couponResp.status_code === 200) {
                this.storageService.setLocalStore(VOUCHER_SIGNIN, '1');
                const operatorVoucher = this.storageService.getLocalStore('operator_voucher');
                if(operatorVoucher) {
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { step: '5', auth: null },
                    queryParamsHandling: 'merge'
                  })
                } else this.router.navigateByUrl('/voucher/success');
              } else {
                if (couponResp.error && couponResp.error.code !== 1002) {
                  this.uikitService.notifyError(couponResp);
                }
                this.router.navigateByUrl('/home')
              }
              this.storageService.removeLocalStore('discount_code');
              this.storageService.removeLocalStore('discount_type');
              this.storageService.removeLocalStore('operator_voucher');
            }
            else if (discountCode && (discountType === BULSATCODE || discountType === VODAFONE_ROMANIA)) {
              const Coupendata = { code: discountCode, operator_reference_number:this.storageService.getLocalStore('operatorReference'),customer_identifier_type:this.storageService.getLocalStore('customerIdentifierType')};
              const couponResp: any = await this.voucherService.bulsatSubcription(Coupendata);
              if (couponResp.status_code === 200) {
                this.storageService.setLocalStore(VOUCHER_SIGNIN, '1');
                const operatorVoucher = this.storageService.getLocalStore('operator_voucher');
                if(operatorVoucher) {
                  this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { step: '5', auth: null },
                    queryParamsHandling: 'merge'
                  })
                } else this.router.navigateByUrl('/voucher/success');
              } else {
                if (couponResp.error && couponResp.error.code !== 1002) {
                  this.uikitService.notifyError(couponResp);
                }
                this.router.navigateByUrl('/home')
              }
              this.storageService.removeLocalStore('discount_code');
              this.storageService.removeLocalStore('discount_type');
              this.storageService.removeLocalStore('operator_voucher');
            }
            else if (discountCode && discountType === COUPON) {
              this.storageService.setLocalStore(VOUCHER_SIGNIN, '1');
              this.router.navigateByUrl('/voucher/plan')
            } else if (authenticate) {
              this.storageService.removeLocalStore('authenticate');
              if(this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
              if(this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
            } else if (contentURL) {
              this.storageService.removeLocalStore('contentURL');
              location.href = contentURL;
            } else {
              this.router.navigateByUrl('/home');
            }
            this.storageService.removeLocalStore('authErrorCounter');
            this.baseService.signinCaptchaValidation.next(0);
          } else {
            this.baseService.signinCounterErrorFn();
            const datalayerData = {
              event: 'GAEvent',
              eventCategory: 'Membership Actions',
              eventAction: 'Login',
              eventLabel: 'Error -' + data.login_by + '/Username',
              loginStatus: 'False',
              userId: '',
              notificationStatus: localStorage.getItem('emailNotify') ||  'False',
              region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
              platform: this.baseService.browserType,
              userType: this.storageService.getLocalStore('user_type'),
              operatorName: this.storageService.getLocalStore('operator_name')
            }
            this.datalayerService.addDatalayer(datalayerData);
          }
          resolve(true);
        },
        (error: HttpErrorResponse) => {
          this.baseService.signLoaderSource.next(false);
          this.baseService.signinCounterErrorFn();
          const datalayerData = {
            event: 'GAEvent',
            eventCategory: 'Membership Actions',
            eventAction: 'Login',
            eventLabel: 'Error -' + data.login_by + '/Username',
            loginStatus: 'False',
            userId: '',
            notificationStatus: localStorage.getItem('emailNotify') ||  'False',
            region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
            platform: this.baseService.browserType,
            userType: this.storageService.getLocalStore('user_type'),
            operatorName: this.storageService.getLocalStore('operator_name')
          };
          this.datalayerService.addDatalayer(datalayerData);
          if(data.code)
            this.uikitService.staticErrorMessage(error.error.error.message);
          resolve(false);
        }
      );
    })
  }

  operatorLogin(postData): Observable<any>{
    const type = this.storageService.getLocalStore('operatorIntegrationType');
    const ssoLoginUrl = environment.apiEndpoint + environment.version + ((type === 'ftp' || type === 'sso' || type === 'soap') ? operatorLogin : login);
    return this.http.post(ssoLoginUrl, postData);
  }
}
